import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createQuoteLineItem, updateQuoteLineItem, deleteQuoteLineItem } from '../api/quotesApi';

// Single hook wrapping the three line-item mutations. The row component would
// otherwise juggle three useMutation calls plus its own local state. Each
// line-item write triggers UpdateQuoteDetail + UpdateQuoteTable on the server;
// useQuote owns the invalidation via its SignalR subscription, so we don't
// touch the cache here.
export default function useQuoteLineItemMutations(quoteId) {
    const create = useMutation({
        mutationFn: (body) => createQuoteLineItem(quoteId, body),
        onError: (err) => toast.error(err?.message ?? 'Failed to add line item'),
    });

    const update = useMutation({
        mutationFn: ({ id, body }) => updateQuoteLineItem(id, body),
        onError: (err) => toast.error(err?.message ?? 'Failed to update line item'),
    });

    const remove = useMutation({
        mutationFn: (id) => deleteQuoteLineItem(id),
        onError: (err) => toast.error(err?.message ?? 'Failed to delete line item'),
    });

    return { create, update, remove };
}
